import m from "mithril";
import assistant from "../../askbar/assistant";
import Sorter from "../../app/dnd/dnd";
import Btn from "../../app/components/button/index";
import {Icon, Icons, Dialog, Button} from "../../old/plugins/construct-ui";
import dayjs from "dayjs";
import relativetime from "dayjs/plugin/relativeTime";
dayjs.extend(relativetime);

export default ({attrs: {editable, customformat, text, onUpdate}}) => {
	let options = (customformat.options || []).map((i) => {
		return {id: i.id || i, caption: i.caption || i.id || i};
	});
	let selectedlist = [];

	if (text) selectedlist = JSON.parse(text);

	// console.log({selectedlist});

	selectedlist = selectedlist.map((i) => {
		return {...i, id: i.id || i, caption: i.caption || i.id || i};
	});

	let tempSelectedList = [];

	let dialogvisible = false;

	function ShowDialog() {
		tempSelectedList = JSON.parse(JSON.stringify(selectedlist));
		dialogvisible = true;
	}
	function DialogCancelled() {
		dialogvisible = false;
	}

	return {
		view: () => {
			let lastitem = selectedlist
				.filter((a) => a.completed)
				.slice(-1)
				.pop();
			let nextitem = selectedlist
				.filter((a) => !a.completed)
				.slice(0, 1)
				.pop();

			//there are 2 stages: 1 normal display of data 2: when editable allow clicking to show popup
			return m(
				"task-list-1-.wrapper",
				{
					style: {
						display: "flex",
						padding: "0.5rem",
						gap: "0.5rem",
						"flex-direction": "column",
						"background-color": editable && "#ffebcd",
						height: "100%",
						width: "100%",
						"place-content": "center",
					},
					onclick: () => {
						if (!dialogvisible && selectedlist.length > 0) {
							ShowDialog();
						}
					},
				},
				[
					m(
						".task-list-1.list-display",
						{
							style: {
								display: "flex",
								gap: "0.5rem",
								"align-items": "center",
							},
						},
						selectedlist.map((a) =>
							m(".tag", {
								style: {
									padding: "0.25rem 0.5rem",
									border: "1px solid lightblue",
									"line-height": "1rem",
									"user-select": "none",
									"background-color": a.completed ? "green" : "white",
									width: "1.5rem",
									height: "1.5rem",
									"border-radius": "0.5rem",
								},
								title: `${a.caption}${
									a.completed
										? `: ${dayjs(a.completedon).fromNow()} (${dayjs(a.completedon).format("YYYY-MM-DD HH:mm:ss")})`
										: ""
								}`,
							})
						)
					),
					selectedlist.length > 0 &&
						m(
							".activity-status",
							{
								style: {
									"line-height": "1rem",
									// "text-align": "center",
								},
							},
							[lastitem ? lastitem.caption : "Start", "->", nextitem ? nextitem.caption : "Completed"]
						),
					m(Dialog, {
						class: "something-check",
						autofocus: true,
						basic: true,
						closeOnEscapeKey: true,
						closeOnOutsideClick: true,
						content: m(
							".process-content",
							{
								style: {
									display: "grid",
									gap: "2rem",
									padding: "1rem",
									"grid-template-columns": "40ch 40ch",
								},
							},
							[
								m(
									".select-sequence-1.list-display",
									{
										style: {
											display: "flex",
											gap: "0.5rem",
											padding: "0.5rem",
											height: "100%",
											width: "100%",
										},
									},
									tempSelectedList.map((a, ai) =>
										m(
											".tag",
											{
												style: {
													padding: "0.25rem 0.5rem",
													border: "1px solid lightblue",
													"user-select": "none",
													background: "white",
													cursor: "pointer",
													"background-color": a.completed ? "green" : "white",
													color: a.completed ? "white" : undefined,
												},
												onclick: () => {
													tempSelectedList.forEach((b, bi) => {
														if (editable) {
															let targetVal = !b.completed;

															if (targetVal)
																if (bi <= ai) {
																	b.completed = targetVal;
																	if (bi == ai) b.completedon = dayjs().format("YYYY-MM-DD HH:mm:ss");
																	if (!b.completedon) b.completedon = dayjs().format("YYYY-MM-DD HH:mm:ss");
																}
															if (!targetVal)
																if (bi >= ai) {
																	b.completed = targetVal;
																	if (bi == ai) b.completedon = dayjs().format("YYYY-MM-DD HH:mm:ss");
																}
														}
													});
													let isdueSet = false;
													tempSelectedList.forEach((b, bi) => {
														if (b.completedon) {
															delete b.isdue;
														} else {
															if (!isdueSet) {
																b.isdue = true;
																isdueSet = true;
															}
														}
													});
												},
											},
											a.caption
										)
									)
								),
							]
						),
						hasBackdrop: true,
						isOpen: dialogvisible,
						inline: false,
						onClose: DialogCancelled,
						// title: "Select",
						transitionDuration: 200,
						footer: m(`.cui-align-right`, [
							m(Button, {
								label: editable ? "Cancel" : "Close",
								onclick: () => {
									DialogCancelled();
								},
							}),
							editable &&
								m(Button, {
									intent: "primary",
									label: "Save",
									onclick: () => {
										selectedlist = JSON.parse(JSON.stringify(tempSelectedList));
										if (onUpdate) {
											onUpdate(JSON.stringify(selectedlist));
										}
										dialogvisible = false;
									},
								}),
						]),
					}),
				]
			);
		},
	};
};
